import type { FunctionComponent } from 'react'
import { useTranslate } from '../../contexts/TranslationContext'
import SvgWarningTriangle from '../../svg/icons/WarningTriangle'
import { Message } from './Message'

export const EmptyAllergens: FunctionComponent = () => {
	const translate = useTranslate()
	return <Message icon={<SvgWarningTriangle />} text={translate('EmptyAllergens.text')} />
}
